import React from 'react';

/**
 * @typedef CLNode
 * @property {string | number} lineId
 * @property {'start' | 'end'} side
 * @property {{ x: number, y: number }} position
 */

const ConnectingLinesContext = React.createContext({
    /**
     * @param {CLNode} info
     * @returns {() => void} unregister()
     */
    registerNode(info) { throw new Error('No ConnectingLinesContext in tree.'); },
});

export default ConnectingLinesContext;